export default "__VITE_ASSET__D5mvx8BK__"